export default function registrationFieldReducer(state, action) {
  if (action.type === 'register') {
    return {
      ...state,
      [action.field]: action.section,
    };
  }

  if (action.type === 'unregister') {
    return {
      ...state,
      [action.field]: undefined,
    };
  }
  return state;
}
